import { ProcessType, } from "Qrc/lib/generated/enum";
import { isAttachment, isSheetMaterial, isSegment, isStringIndexedInterface, isPoint3, isScrewThread, } from "Qrc/lib/generated/typeguard";
import { isNodeUserDataEntry, isNodeUserDataEntryType, isTappingDataEntry, } from "Qrc/lib/userdata_config";
import { getKeysOfObject, hasOptionalPropertyT, hasPropertyT, isArray, isBoolean, isInstanceOf, isNumber, isObject, isString, } from "Qrc/lib/utils";
export function isTappingCandidate3(arg) {
    const typeGuardMap = {
        center3: isPoint3,
        matchingScrewThreads: (n) => isArray(n, isScrewThread),
    };
    return isStringIndexedInterface(arg) && getKeysOfObject(typeGuardMap)
        .every(key => typeGuardMap[key](arg[key]));
}
export function isTappingNodeData(arg) {
    const typeGuardMap = {
        laserSheetCuttingVertexKey: isString,
        candidates: (n) => isArray(n, isTappingCandidate3),
        selection: (n) => isArray(n, isTappingDataEntry),
        svg: isString,
    };
    return isStringIndexedInterface(arg) && getKeysOfObject(typeGuardMap)
        .every(key => typeGuardMap[key](arg[key]));
}
export function getAdditionalProcesses() {
    return {
        mechanicalDeburring: [
            ProcessType.automaticMechanicalDeburring,
            ProcessType.manualMechanicalDeburring,
        ],
        slideGrinding: [ProcessType.slideGrinding],
        threading: [ProcessType.userDefinedThreading],
        countersinking: [ProcessType.userDefinedCountersinking],
        tapping: [ProcessType.sheetTapping],
    };
}
export function isAdditionalProcess(p) {
    for (const key of Object.keys(getAdditionalProcesses())) {
        if (p === key) {
            return true;
        }
    }
    return false;
}
function isAdditionalProcessUserDataEntry(obj) {
    if (!isStringIndexedInterface(obj)) {
        return false;
    }
    const key = obj["key"];
    if (!isNodeUserDataEntry(key)) {
        return false;
    }
    const value = obj["value"];
    return isNodeUserDataEntryType(key, value);
}
function isAddOrRemoveAdditionalProcess(obj) {
    return typeof obj === "object"
        && obj !== null
        && hasPropertyT(obj, "process", isAdditionalProcess)
        && hasPropertyT(obj, "addNode", isBoolean)
        && hasOptionalPropertyT(obj, "userDataEntries", (t) => isArray(t, isAdditionalProcessUserDataEntry));
}
export function isTubeCuttingParams(arg) {
    return isInstanceOf(arg, {
        processId: isString,
        tubeId: isString,
    });
}
export function isGraphNodeWritableAttributes(obj) {
    const graphNodeWritableAttributesTypeGuards = {
        articleName: isString,
        articleExternalPartNumber: isString,
        articleExternalDrawingNumber: isString,
        articleExternalRevisionNumber: isString,
        attachments: (t) => isArray(t, isAttachment),
        flipSide: isBoolean,
        comment: isString,
        cuttingGas: isString,
        fixedRotations: (t) => isArray(t, isNumber),
        sheetMaterial: isSheetMaterial,
        importMultiplicity: isNumber,
        testReportRequired: isBoolean,
        thickness: isNumber,
        tubeCuttingEditParams: isTubeCuttingParams,
        forceSheetMetalPart: isBoolean,
    };
    function hasOptionalValue(u, key) {
        return hasOptionalPropertyT(u, key, (value) => graphNodeWritableAttributesTypeGuards[key](value));
    }
    if (!isObject(obj)) {
        return false;
    }
    return getKeysOfObject(graphNodeWritableAttributesTypeGuards)
        .every(key => hasOptionalValue(obj, key));
}
export function isVertexKeyWithChangeData(obj) {
    return typeof obj === "object"
        && obj !== null
        && hasPropertyT(obj, "vertexKey", isString)
        && hasPropertyT(obj, "attributes", isGraphNodeWritableAttributes)
        && hasPropertyT(obj, "additionalProcesses", (t) => isArray(t, isAddOrRemoveAdditionalProcess));
}
export function isPartCreationInformation(arg) {
    const typeGuardMap = {
        segments: (n) => isArray(n, isSegment),
        thickness: isNumber,
        name: isString,
        material: isSheetMaterial,
        gasId: isString,
    };
    return isStringIndexedInterface(arg) && getKeysOfObject(typeGuardMap)
        .every(key => typeGuardMap[key](arg[key]));
}
export function isConfigFlags(arg) {
    const guardMap = {
        tubesEnabled: isBoolean,
    };
    return isStringIndexedInterface(arg) && getKeysOfObject(guardMap)
        .every(key => guardMap[key](arg[key]));
}
